import { registerLocaleData } from "@angular/common";
import { Injectable } from "@angular/core";

const DEFAULT_LOCALE_ID = "it";

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  supportedImports = ["it", "es", "en"];

  constructor() {}

  getUsersLocale(): string {
    if (
      typeof window === "undefined" ||
      typeof window.navigator === "undefined"
    ) {
      return DEFAULT_LOCALE_ID;
    }
    const wn = window.navigator as any;
    let lang = wn.languages ? wn.languages[0] : DEFAULT_LOCALE_ID;
    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
    return this.getLang(lang);
  }

  private getLang(lang: string): string {
    return this.supportedImports.includes(lang) ? lang : DEFAULT_LOCALE_ID;
  }
}
